// extracted by mini-css-extract-plugin
export default {"downloadButton":"download_button-module___downloadButton___dac5db70"};